import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)]" }
const _hoisted_2 = { class: "fixed top-[72px] left-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_4 = { class: "w-[220px] flex justify-end space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Save & Display", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Save Form", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-[72px]"
}
const _hoisted_8 = { class: "bg-primary-100" }

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import FormSection from "./FormSection.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";

import { errorResponse } from "@/helpers/errorMessage";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

import PageLoader from "@/components/loaders/PageLoader.vue"

import { filters } from "@/interfaces/pages/FilterPageInterface";

import InterventionTypeService from "@/classes/Settings/InterventionTypeService.ts"
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const route = useRoute();
const router = useRouter();


const parentForm = ref<number>(route?.params?.form);

const form = ref<any>({});

const formFieldTypes = ref<any>({});
const existingDropdowns = ref<any>({});

const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);
const saving = ref<boolean>(false);
const successMessage = ref<string>("Data has been successfully updated!");

const errors = ref<any>();
const filterSearch = ref<any>(route.query.query);
const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);

const newForm = ref<boolean>(false);
const formOpen = ref<boolean>(false);
	
const errorMessage = ref<string>('');
const showError = ref<boolean>(false);
/**
 * METHODS
 */
const tabs = ref<{ name: string; count: number; tab: string; href: string; allowed: boolean }[]>([
	{
		name: "Form Builder",
		count: 0,
		tab: "",
		href: `/settings/intervention-types/view`,
		allowed: true,
	}
]);

const save = (): void => {

	saving.value = true;
	
	InterventionTypeService
		.store(
			parentForm.value,
			{ form: form.value }
		)
		.then((response: any) => {
			redirectSuccess()
		})
		.catch((error: any) => {
			showError.value = true;
            errors.value = error.response.data.errors;
			errorMessage.value = Object.values(errors.value)[0]
		})
		.finally(() => saving.value = false);
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/settings/intervention-types/index");
};

/**
 * METHODS
 */
const getData = (): void => {

	loading.value = true;
	
	InterventionTypeService
		.create(parentForm.value)
		.then((response: any) => {
			form.value = response.data.form;
			formFieldTypes.value = response.data.formFieldTypes;
			existingDropdowns.value = response.data.existingDropdowns
		})
		.catch((error: any) => {
			console.log(error);
		})
		.finally(() => loading.value = false);
};

onMounted(() => {
	getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { mainCustomClass: "intervention-generator" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/settings/intervention-types/index')))
          }, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"]),
          _createElementVNode("div", _hoisted_4, [
            (newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  customClass: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  disabled: formOpen.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (save())),
                  customClass: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(FormSection, {
                  form: form.value,
                  formFieldTypes: formFieldTypes.value,
                  existingDropdowns: existingDropdowns.value,
                  onOpen: _cache[2] || (_cache[2] = ($event: any) => (formOpen.value = true)),
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (formOpen.value = false))
                }, null, 8, ["form", "formFieldTypes", "existingDropdowns"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ErrorModal, {
        show: showError.value,
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showError.value = false)),
        "action-text": "Close",
        title: "Error!",
        content: errorMessage.value
      }, null, 8, ["show", "content"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: saving.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})